import React from 'react'
import { Box } from '@mui/material';

import centerImg from '../../data/images/center.png';
import centerImg_mobile from '../../data/images/center_mobile.png';

type Props = {}

const Center = (props: Props) => {

  const webWidth = window.innerWidth;
  
  return (
    <>
      <Box 
          sx={{ 
          width: '100%', 
          height: 'auto', 
          // border: '1px solid black',
          // backgroundColor: 'black',
          p: 0,
          mt: '8em',
          mb: '3em'
          }}>
          {
              webWidth > 1300
              ?
              <img src={centerImg} width={'100%'} />
              :
              <img src={centerImg_mobile} width={'100%'} />
          }
      </Box>
    </>
  )
}

export default Center